import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/E3_Farm.svg"

const E3Farm: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 49 49'} component={Icon} {...props} fill="currentColor" />
export default E3Farm
